export let GPHardinessData = {
  "zones": [
      {
        "-name": "Australia",
        "-id": "3900",
        "pr": [
          {
            "-pid": "3900",
            "-id": "3901",
            "-name": "Northern coast",
            "-zone": "5"
          },
          {
            "-pid": "3900",
            "-id": "3902",
            "-name": "Northern interior and east coast",
            "-zone": "4"
          },
          {
            "-pid": "3900",
            "-id": "3903",
            "-name": "Southern interior and coast",
            "-zone": "3"
          },
          {
            "-pid": "3900",
            "-id": "3904",
            "-name": "Mountains and central Tasmania",
            "-zone": "2"
          }
        ]
      },
      {
        "-name": "Canada",
        "-id": "40",
        "pr": [
          {
            "-pid": "40",
            "-id": "4000",
            "-name": "Ontario",
            "-zone": "3"
          },
          {
            "-pid": "40",
            "-id": "4001",
            "-name": "Quebec",
            "-zone": "2"
          },
          {
            "-pid": "40",
            "-id": "4002",
            "-name": "Nova Scotia",
            "-zone": "6"
          },
          {
            "-pid": "40",
            "-id": "4003",
            "-name": "New Brunswick",
            "-zone": "4"
          },
          {
            "-pid": "40",
            "-id": "4004",
            "-name": "Manitoba",
            "-zone": "3"
          },
          {
            "-pid": "40",
            "-id": "4005",
            "-name": "British Columbia",
            "-zone": "5"
          },
          {
            "-pid": "40",
            "-id": "4006",
            "-name": "Prince Edward Island",
            "-zone": "6"
          },
          {
            "-pid": "40",
            "-id": "4007",
            "-name": "Saskatchewan",
            "-zone": "4"
          },
          {
            "-pid": "40",
            "-id": "4008",
            "-name": "Alberta",
            "-zone": "4"
          },
          {
            "-pid": "40",
            "-id": "4009",
            "-name": "Newfoundland and Labrador",
            "-zone": "2"
          },
          {
            "-pid": "40",
            "-id": "4010",
            "-name": "Northwest Territories",
            "-zone": "1"
          },
          {
            "-pid": "40",
            "-id": "4011",
            "-name": "Yukon",
            "-zone": "1"
          },
          {
            "-pid": "40",
            "-id": "4012",
            "-name": "Nunavut",
            "-zone": "1"
          }
        ]
      },
      {
        "-name": "United Kingdom",
        "-id": "1",
        "pr": [
          {
            "-pid": "1",
            "-id": "100",
            "-name": "England",
            "-zone": "8"
          },
          {
            "-pid": "1",
            "-id": "101",
            "-name": "N Ireland",
            "-zone": "9"
          },
          {
            "-pid": "1",
            "-id": "102",
            "-name": "Scotland",
            "-zone": "8"
          },
          {
            "-pid": "1",
            "-id": "103",
            "-name": "Wales",
            "-zone": "8"
          }
        ]
      },
      {
        "-name": "United States",
        "-id": "2",
        "pr": [
          {
            "-pid": "2",
            "-id": "200",
            "-name": "Alaska",
            "-zone": "1"
          },
          {
            "-pid": "2",
            "-id": "201",
            "-name": "Alabama",
            "-zone": "8"
          },
          {
            "-pid": "2",
            "-id": "202",
            "-name": "Arkansas",
            "-zone": "7"
          },
          {
            "-pid": "2",
            "-id": "203",
            "-name": "Arizona",
            "-zone": "9"
          },
          {
            "-pid": "2",
            "-id": "204",
            "-name": "California",
            "-zone": "9"
          },
          {
            "-pid": "2",
            "-id": "205",
            "-name": "Colorado",
            "-zone": "5"
          },
          {
            "-pid": "2",
            "-id": "206",
            "-name": "Connecticut",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "207",
            "-name": "Washington, D.C.",
            "-zone": "7"
          },
          {
            "-pid": "2",
            "-id": "208",
            "-name": "Delaware",
            "-zone": "7"
          },
          {
            "-pid": "2",
            "-id": "209",
            "-name": "Florida",
            "-zone": "9"
          },
          {
            "-pid": "2",
            "-id": "210",
            "-name": "Georgia",
            "-zone": "8"
          },
          {
            "-pid": "2",
            "-id": "211",
            "-name": "Hawaii",
            "-zone": "10"
          },
          {
            "-pid": "2",
            "-id": "212",
            "-name": "Iowa",
            "-zone": "5"
          },
          {
            "-pid": "2",
            "-id": "213",
            "-name": "Idaho",
            "-zone": "5"
          },
          {
            "-pid": "2",
            "-id": "214",
            "-name": "Illinois",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "215",
            "-name": "Indiana",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "216",
            "-name": "Kansas",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "217",
            "-name": "Kentucky",
            "-zone": "7"
          },
          {
            "-pid": "2",
            "-id": "218",
            "-name": "Louisiana",
            "-zone": "8"
          },
          {
            "-pid": "2",
            "-id": "219",
            "-name": "Massachusetts",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "220",
            "-name": "Maryland",
            "-zone": "7"
          },
          {
            "-pid": "2",
            "-id": "221",
            "-name": "Maine",
            "-zone": "4"
          },
          {
            "-pid": "2",
            "-id": "222",
            "-name": "Michigan",
            "-zone": "5"
          },
          {
            "-pid": "2",
            "-id": "223",
            "-name": "Minnesota",
            "-zone": "4"
          },
          {
            "-pid": "2",
            "-id": "224",
            "-name": "Missouri",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "225",
            "-name": "Mississippi",
            "-zone": "8"
          },
          {
            "-pid": "2",
            "-id": "226",
            "-name": "Montana",
            "-zone": "4"
          },
          {
            "-pid": "2",
            "-id": "227",
            "-name": "North Carolina",
            "-zone": "8"
          },
          {
            "-pid": "2",
            "-id": "228",
            "-name": "North Dakota",
            "-zone": "4"
          },
          {
            "-pid": "2",
            "-id": "229",
            "-name": "Nebraska",
            "-zone": "5"
          },
          {
            "-pid": "2",
            "-id": "230",
            "-name": "New Hampshire",
            "-zone": "5"
          },
          {
            "-pid": "2",
            "-id": "231",
            "-name": "New Jersey",
            "-zone": "7"
          },
          {
            "-pid": "2",
            "-id": "232",
            "-name": "New Mexico",
            "-zone": "7"
          },
          {
            "-pid": "2",
            "-id": "233",
            "-name": "Nevada",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "234",
            "-name": "New York",
            "-zone": "5"
          },
          {
            "-pid": "2",
            "-id": "235",
            "-name": "Ohio",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "236",
            "-name": "Oklahoma",
            "-zone": "7"
          },
          {
            "-pid": "2",
            "-id": "237",
            "-name": "Oregon",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "238",
            "-name": "Pennsylvania",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "239",
            "-name": "Rhode Island",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "240",
            "-name": "South Carolina",
            "-zone": "8"
          },
          {
            "-pid": "2",
            "-id": "241",
            "-name": "South Dakota",
            "-zone": "4"
          },
          {
            "-pid": "2",
            "-id": "242",
            "-name": "Tennessee",
            "-zone": "7"
          },
          {
            "-pid": "2",
            "-id": "243",
            "-name": "Texas",
            "-zone": "8"
          },
          {
            "-pid": "2",
            "-id": "244",
            "-name": "Utah",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "245",
            "-name": "Virginia",
            "-zone": "8"
          },
          {
            "-pid": "2",
            "-id": "246",
            "-name": "Vermont",
            "-zone": "5"
          },
          {
            "-pid": "2",
            "-id": "247",
            "-name": "Washington",
            "-zone": "6"
          },
          {
            "-pid": "2",
            "-id": "248",
            "-name": "Wisconsin",
            "-zone": "4"
          },
          {
            "-pid": "2",
            "-id": "249",
            "-name": "West Virginia",
            "-zone": "7"
          },
          {
            "-pid": "2",
            "-id": "250",
            "-name": "Wyoming",
            "-zone": "4"
          }
        ]
      },
      {
        "-name": "Poland",
        "-id": "7",
        "pr": [
          {
            "-pid": "7",
            "-id": "2700",
            "-name": "Dolnośląskie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2701",
            "-name": "Kujawsko-Pomorskie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2702",
            "-name": "Łódzkie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2703",
            "-name": "Lubelskie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2704",
            "-name": "Lubuskie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2705",
            "-name": "Małopolskie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2706",
            "-name": "Mazowieckie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2707",
            "-name": "Opolskie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2708",
            "-name": "Podkarpackie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2709",
            "-name": "Podlaskie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2710",
            "-name": "Pomorskie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2711",
            "-name": "Śląskie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2712",
            "-name": "Świętokrzyskie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2713",
            "-name": "Warmińsko-Mazurskie",
            "-zone": "5"
          },
          {
            "-pid": "7",
            "-id": "2714",
            "-name": "Wielkopolskie",
            "-zone": "6"
          },
          {
            "-pid": "7",
            "-id": "2715",
            "-name": "Zachodniopomorskie",
            "-zone": "7"
          }
        ]
      },
      {
          "-id": "300",
          "-name": "Austria",
          "-zone": "5"
      },
      {
          "-id": "400",
          "-name": "Bosnia and Herzegovina",
          "-zone": "7"
      },
      {
          "-id": "500",
          "-name": "Belgium",
          "-zone": "8"
      },
      {
          "-id": "600",
          "-name": "Bulgaria",
          "-zone": "6"
      },
      {
          "-id": "700",
          "-name": "Croatia",
          "-zone": "6"
      },
      {
          "-id": "800",
          "-name": "Czech Republic",
          "-zone": "6"
      },
      {
          "-id": "900",
          "-name": "Danmark",
          "-zone": "8"
      },
      {
          "-id": "1000",
          "-name": "Estonia",
          "-zone": "5"
      },
      {
          "-id": "1100",
          "-name": "Finland",
          "-zone": "4"
      },
      {
        "-name": "France",
        "-id": "3",        
        "pr": [
          {
            "-pid": "3",
            "-id": "1200",
            "-name": "Aquitaine",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1201",
            "-name": "Auvergne",
            "-zone": "7"
          },
          {
            "-pid": "3",
            "-id": "1202",
            "-name": "Basse-Normandie",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1203",
            "-name": "Bourgogne",
            "-zone": "7"
          },
          {
            "-pid": "3",
            "-id": "1204",
            "-name": "Brittany",
            "-zone": "9"
          },
          {
            "-pid": "3",
            "-id": "1205",
            "-name": "Centre",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1206",
            "-name": "Champagne-Ardenne",
            "-zone": "7"
          },
          {
            "-pid": "3",
            "-id": "1207",
            "-name": "Corsica",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1208",
            "-name": "Franche-Comté",
            "-zone": "7"
          },
          {
            "-pid": "3",
            "-id": "1209",
            "-name": "Haute-Normandie",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1210",
            "-name": "Île-de-France",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1211",
            "-name": "Languedoc-Roussillon",
            "-zone": "9"
          },
          {
            "-pid": "3",
            "-id": "1212",
            "-name": "Limousin",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1213",
            "-name": "Lorraine",
            "-zone": "7"
          },
          {
            "-pid": "3",
            "-id": "1214",
            "-name": "Midi-Pyrénées",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1215",
            "-name": "Nord-Pas-de-Calais",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1216",
            "-name": "Pays de la Loire",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1217",
            "-name": "Picardie",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1218",
            "-name": "Poitou-Charentes",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1219",
            "-name": "Provence-Alpes-Côte d'Azur",
            "-zone": "8"
          },
          {
            "-pid": "3",
            "-id": "1220",
            "-name": "Rhône-Alpes",
            "-zone": "7"
          },
          {
            "-pid": "3",
            "-id": "1221",
            "-name": "Alsace",
            "-zone": "7"
          }
        ]
      },
      {
        "-name": "Germany",
        "-id": "4",
        "pr": [
          {
            "-pid": "4",
            "-id": "1300",
            "-name": "Baden-Württemberg",
            "-zone": "6"
          },
          {
            "-pid": "4",
            "-id": "1301",
            "-name": "Bavaria",
            "-zone": "6"
          },
          {
            "-pid": "4",
            "-id": "1302",
            "-name": "Bremen",
            "-zone": "8"
          },
          {
            "-pid": "4",
            "-id": "1303",
            "-name": "Hamburg",
            "-zone": "8"
          },
          {
            "-pid": "4",
            "-id": "1304",
            "-name": "Hesse",
            "-zone": "7"
          },
          {
            "-pid": "4",
            "-id": "1305",
            "-name": "Lower Saxony",
            "-zone": "7"
          },
          {
            "-pid": "4",
            "-id": "1306",
            "-name": "North Rhine-Westphalia",
            "-zone": "7"
          },
          {
            "-pid": "4",
            "-id": "1307",
            "-name": "Rhineland-Palatinate",
            "-zone": "7"
          },
          {
            "-pid": "4",
            "-id": "1308",
            "-name": "Saarland",
            "-zone": "7"
          },
          {
            "-pid": "4",
            "-id": "1309",
            "-name": "Schleswig-Holstein",
            "-zone": "8"
          },
          {
            "-pid": "4",
            "-id": "1310",
            "-name": "Brandenburg",
            "-zone": "6"
          },
          {
            "-pid": "4",
            "-id": "1311",
            "-name": "Mecklenburg-Vorpommern",
            "-zone": "7"
          },
          {
            "-pid": "4",
            "-id": "1312",
            "-name": "Saxony",
            "-zone": "6"
          },
          {
            "-pid": "4",
            "-id": "1313",
            "-name": "Saxony-Anhalt",
            "-zone": "6"
          },
          {
            "-pid": "4",
            "-id": "1314",
            "-name": "Thuringia",
            "-zone": "6"
          },
          {
            "-pid": "4",
            "-id": "1315",
            "-name": "Berlin",
            "-zone": "6"
          }
        ]
      },
      {
          "-id": "1400",
          "-name": "Greece",
          "-zone": "9"
      },
      {
          "-id": "1500",
          "-name": "Hungary",
          "-zone": "6"
      },
      {
          "-id": "1600",
          "-name": "Ireland",
          "-zone": "9"
      },
      {
          "-id": "1700",
          "-name": "Israel",
          "-zone": "10"
      },
      {
          "-id": "1800",
          "-name": "Iceland",
          "-zone": "6"
      },
      {
        "-name": "Italy",
        "-id": "5",
        "pr": [
          {
            "-pid": "5",
            "-id": "1900",
            "-name": "Abruzzo",
            "-zone": "9"
          },
          {
            "-pid": "5",
            "-id": "1901",
            "-name": "Basilicate",
            "-zone": "10"
          },
          {
            "-pid": "5",
            "-id": "1902",
            "-name": "Calabria",
            "-zone": "10"
          },
          {
            "-pid": "5",
            "-id": "1903",
            "-name": "Campania",
            "-zone": "10"
          },
          {
            "-pid": "5",
            "-id": "1904",
            "-name": "Emilia-Romagna",
            "-zone": "8"
          },
          {
            "-pid": "5",
            "-id": "1905",
            "-name": "Friuli",
            "-zone": "7"
          },
          {
            "-pid": "5",
            "-id": "1906",
            "-name": "Latium",
            "-zone": "9"
          },
          {
            "-pid": "5",
            "-id": "1907",
            "-name": "Liguria",
            "-zone": "9"
          },
          {
            "-pid": "5",
            "-id": "1908",
            "-name": "Lombardy",
            "-zone": "8"
          },
          {
            "-pid": "5",
            "-id": "1909",
            "-name": "The Marches",
            "-zone": "9"
          },
          {
            "-pid": "5",
            "-id": "1910",
            "-name": "Molise",
            "-zone": "9"
          },
          {
            "-pid": "5",
            "-id": "1911",
            "-name": "Piedmont",
            "-zone": "8"
          },
          {
            "-pid": "5",
            "-id": "1912",
            "-name": "Apulia",
            "-zone": "10"
          },
          {
            "-pid": "5",
            "-id": "1913",
            "-name": "Sardinia",
            "-zone": "9"
          },
          {
            "-pid": "5",
            "-id": "1914",
            "-name": "Sicily",
            "-zone": "10"
          },
          {
            "-pid": "5",
            "-id": "1915",
            "-name": "Tuscany",
            "-zone": "9"
          },
          {
            "-pid": "5",
            "-id": "1916",
            "-name": "Trentino-Alto Adige",
            "-zone": "6"
          },
          {
            "-pid": "5",
            "-id": "1917",
            "-name": "Umbria",
            "-zone": "9"
          },
          {
            "-pid": "5",
            "-id": "1918",
            "-name": "Aosta Valley",
            "-zone": "7"
          },
          {
            "-pid": "5",
            "-id": "1919",
            "-name": "Veneto",
            "-zone": "8"
          }
        ]
      },
      {
          "-id": "2000",
          "-name": "Japan",
          "-zone": "7"
      },
      {
          "-id": "2100",
          "-name": "Lithuania",
          "-zone": "5"
      },
      {
          "-id": "2200",
          "-name": "Latvia",
          "-zone": "5"
      },
      {
          "-id": "2300",
          "-name": "Montenegro",
          "-zone": "6"
      },
      {
          "-id": "2400",
          "-name": "Macedonia",
          "-zone": "6"
      },
      {
          "-id": "2500",
          "-name": "Netherlands",
          "-zone": "8"
      },
      {
        "-name": "Norway",
        "-id": "6",
        "pr": [
          {
            "-pid": "6",
            "-id": "2600",
            "-name": "Akershus",
            "-zone": "5"
          },
          {
            "-pid": "6",
            "-id": "2601",
            "-name": "Aust-Agder",
            "-zone": "8"
          },
          {
            "-pid": "6",
            "-id": "2602",
            "-name": "Buskerud",
            "-zone": "6"
          },
          {
            "-pid": "6",
            "-id": "2603",
            "-name": "Finnmark",
            "-zone": "3"
          },
          {
            "-pid": "6",
            "-id": "2604",
            "-name": "Hedmark",
            "-zone": "4"
          },
          {
            "-pid": "6",
            "-id": "2605",
            "-name": "Hordaland",
            "-zone": "8"
          },
          {
            "-pid": "6",
            "-id": "2606",
            "-name": "Møre og Romsdal",
            "-zone": "8"
          },
          {
            "-pid": "6",
            "-id": "2607",
            "-name": "Nordland",
            "-zone": "6"
          },
          {
            "-pid": "6",
            "-id": "2608",
            "-name": "Nord-Trøndelag",
            "-zone": "7"
          },
          {
            "-pid": "6",
            "-id": "2609",
            "-name": "Oppland",
            "-zone": "6"
          },
          {
            "-pid": "6",
            "-id": "2610",
            "-name": "Oslo county",
            "-zone": "6"
          },
          {
            "-pid": "6",
            "-id": "2611",
            "-name": "Østfold",
            "-zone": "6"
          },
          {
            "-pid": "6",
            "-id": "2612",
            "-name": "Rogaland",
            "-zone": "8"
          },
          {
            "-pid": "6",
            "-id": "2613",
            "-name": "Sogn og Fjordane",
            "-zone": "8"
          },
          {
            "-pid": "6",
            "-id": "2614",
            "-name": "Sør-Trøndelag",
            "-zone": "7"
          },
          {
            "-pid": "6",
            "-id": "2615",
            "-name": "Telemark",
            "-zone": "6"
          },
          {
            "-pid": "6",
            "-id": "2616",
            "-name": "Troms",
            "-zone": "5"
          },
          {
            "-pid": "6",
            "-id": "2617",
            "-name": "Vest-Agder",
            "-zone": "8"
          },
          {
            "-pid": "6",
            "-id": "2618",
            "-name": "Vestfold",
            "-zone": "6"
          }
        ]
      },
      {
          "-id": "2800",
          "-name": "Portugal",
          "-zone": "9"
      },
      {
          "-id": "2900",
          "-name": "Romania",
          "-zone": "5"
      },
      {
          "-id": "3000",
          "-name": "Russia",
          "-zone": "3"
      },
      {
          "-id": "3100",
          "-name": "Serbia",
          "-zone": "6"
      },
      {
          "-id": "3200",
          "-name": "Slovakia",
          "-zone": "5"
      },
      {
          "-id": "3300",
          "-name": "South Korea",
          "-zone": "6"
      },
      {
        "-name": "Spain",
        "-id": "8",
        "pr": [
          {
            "-pid": "8",
            "-id": "3400",
            "-name": "Ceuta",
            "-zone": "8"
          },
          {
            "-pid": "8",
            "-id": "3401",
            "-name": "Balearic Islands",
            "-zone": "10"
          },
          {
            "-pid": "8",
            "-id": "3402",
            "-name": "La Rioja",
            "-zone": "8"
          },
          {
            "-pid": "8",
            "-id": "3403",
            "-name": "Autonomous Region of Madrid",
            "-zone": "8"
          },
          {
            "-pid": "8",
            "-id": "3404",
            "-name": "Murcia",
            "-zone": "10"
          },
          {
            "-pid": "8",
            "-id": "3405",
            "-name": "Navarre",
            "-zone": "7"
          },
          {
            "-pid": "8",
            "-id": "3406",
            "-name": "Asturias",
            "-zone": "9"
          },
          {
            "-pid": "8",
            "-id": "3407",
            "-name": "Cantabria",
            "-zone": "9"
          },
          {
            "-pid": "8",
            "-id": "3408",
            "-name": "Andalusia",
            "-zone": "9"
          },
          {
            "-pid": "8",
            "-id": "3409",
            "-name": "Aragon",
            "-zone": "8"
          },
          {
            "-pid": "8",
            "-id": "3410",
            "-name": "Canary Islands",
            "-zone": "10"
          },
          {
            "-pid": "8",
            "-id": "3411",
            "-name": "Castille-La Mancha",
            "-zone": "9"
          },
          {
            "-pid": "8",
            "-id": "3412",
            "-name": "Castille and León",
            "-zone": "8"
          },
          {
            "-pid": "8",
            "-id": "3413",
            "-name": "Catalonia",
            "-zone": "8"
          },
          {
            "-pid": "8",
            "-id": "3414",
            "-name": "Extremadura",
            "-zone": "9"
          },
          {
            "-pid": "8",
            "-id": "3415",
            "-name": "Galicia",
            "-zone": "9"
          },
          {
            "-pid": "8",
            "-id": "3416",
            "-name": "Basque Country",
            "-zone": "9"
          },
          {
            "-pid": "8",
            "-id": "3417",
            "-name": "Valencia",
            "-zone": "10"
          }
        ]
      },
      {
          "-id": "3500",
          "-name": "Switzerland",
          "-zone": "5"
      },
      {
        "-name": "Sweden",
        "-id": "9",
        "pr": [
          {
            "-pid": "9",
            "-id": "3600",
            "-name": "Blekinge",
            "-zone": "7"
          },
          {
            "-pid": "9",
            "-id": "3601",
            "-name": "Gävleborg",
            "-zone": "4"
          },
          {
            "-pid": "9",
            "-id": "3602",
            "-name": "Goteborgs Och Bohus",
            "-zone": "7"
          },
          {
            "-pid": "9",
            "-id": "3603",
            "-name": "Gotland",
            "-zone": "7"
          },
          {
            "-pid": "9",
            "-id": "3604",
            "-name": "Halland",
            "-zone": "7"
          },
          {
            "-pid": "9",
            "-id": "3605",
            "-name": "Jämtland",
            "-zone": "4"
          },
          {
            "-pid": "9",
            "-id": "3606",
            "-name": "Jönköping",
            "-zone": "7"
          },
          {
            "-pid": "9",
            "-id": "3607",
            "-name": "Kalmar",
            "-zone": "7"
          },
          {
            "-pid": "9",
            "-id": "3608",
            "-name": "Dalarna",
            "-zone": "5"
          },
          {
            "-pid": "9",
            "-id": "3609",
            "-name": "Kronoberg",
            "-zone": "7"
          },
          {
            "-pid": "9",
            "-id": "3610",
            "-name": "Malmohus",
            "-zone": "7"
          },
          {
            "-pid": "9",
            "-id": "3611",
            "-name": "Norrbotten",
            "-zone": "3"
          },
          {
            "-pid": "9",
            "-id": "3612",
            "-name": "Örebro",
            "-zone": "6"
          },
          {
            "-pid": "9",
            "-id": "3613",
            "-name": "Östergötland",
            "-zone": "6"
          },
          {
            "-pid": "9",
            "-id": "3614",
            "-name": "Södermanland",
            "-zone": "6"
          },
          {
            "-pid": "9",
            "-id": "3615",
            "-name": "Uppsala",
            "-zone": "5"
          },
          {
            "-pid": "9",
            "-id": "3616",
            "-name": "Värmland",
            "-zone": "6"
          },
          {
            "-pid": "9",
            "-id": "3617",
            "-name": "Västerbotten",
            "-zone": "3"
          },
          {
            "-pid": "9",
            "-id": "3618",
            "-name": "Västernorrland",
            "-zone": "4"
          },
          {
            "-pid": "9",
            "-id": "3619",
            "-name": "Västmanland",
            "-zone": "5"
          },
          {
            "-pid": "9",
            "-id": "3620",
            "-name": "Stockholm",
            "-zone": "6"
          },
          {
            "-pid": "9",
            "-id": "3621",
            "-name": "Skåne",
            "-zone": "7"
          },
          {
            "-pid": "9",
            "-id": "3622",
            "-name": "Västra Götaland",
            "-zone": "6"
          }
        ]
      },
      {
          "-id": "3700",
          "-name": "Turkey",
          "-zone": "8"
      },
      {
          "-id": "3800",
          "-name": "Ukraine",
          "-zone": "5"
      }
    ]
};